const {
  LocationPinLockDimensions,
} = require("@styled-icons/fa-solid/LocationPinLock");
const WebFont = require("webfontloader");

exports.onRouteUpdate = () => {
  document.documentElement.classList.remove("sticky-nav__pinned");
  if (window.moduleRegistry) window.moduleRegistry.init();
  if (window.drift) window.drift.page();
  if (window.mutinyPageChange) window.mutinyPageChange();
};

exports.onInitialClientRender = () => {
  const fontsLoaded = sessionStorage.getItem("fonts-loaded") === "true";
  if (fontsLoaded) {
    document.documentElement.classList.add("wf-active");
  } else {
    WebFont.load({
      custom: {
        families: ["nb-international"],
      },
      active: () => {
        sessionStorage.setItem("fonts-loaded", "true");
      },
      inactive: () => {},
    });
  }
};
